<template>
    <v-app>
        <v-content>
            <v-container fluid>
                <div class="main-content">
                    <div class="main-content-center">
                        <v-img src="/piguet.svg" width="350" />
                        <h4>Serveur inaccessible, nous sommes sur le qui-vive! Veuillez nous excuser.</h4>
                        <p>{{ errorMsg }}</p>
                        <p><v-btn @click="reload()" color="primary" flat>Réessayer</v-btn></p>
                    </div>
                </div>
            </v-container>
        </v-content>
        <v-footer app>
            <v-spacer />
            <span>
                &copy;{{ year }},
                <a href="https://www.piguet.com" target="_blank">Piguet.com</a>,
                <a href="https://www.voilab.ch" target="_blank">Voilab</a>
            </span>
        </v-footer>
    </v-app>
</template>

<script>
import moment from 'moment'

export default {
    name: 'pad-error',
    data: () => ({
        year: moment().format('YYYY')
    }),
    computed: {
        errorMsg() {
            return this.currentError.message
        }
    },
    mounted() {
        // eslint-disable-next-line
        console.warn(this.currentError)
    },
    methods: {
        reload() {
            window.location.reload()
        }
    }
}
</script>

<style lang="stylus">
.main-content
    height 100%
    display flex

.main-content-center
    width 100%
    text-align center

.main-content-center v-responsive
    margin 10em auto 2em auto !important
    max-width 350px
    display block
    padding 1px

.footer
    justify-content flex-end

</style>
